import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const OrderItemsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Quantity",
    cell: (row) => String(row.totalItemQuantity),
    expandedCsvCell: (row, expansionIndex) => {
      const quantity = getExpandedItems(row)?.[expansionIndex]?.quantity;
      return quantity ? String(quantity) : "";
    },
  };
